<dac-navbar [doubleNav]="false"></dac-navbar>
<div class="container pt-5 pb-5">
  <div class="row">
    <div class="col">
      <h1 class="h1-responsive">Contact Us</h1>
      <p>Technical support for using the system is provided by Discover and Change, Inc.</p>
      <p>While we typically respond to your questions within 24 hours we guarantee a response to your issues within 7
        business days.
        When you contact us please provide us your username, company name, and the device and browser you are using so
        we can quickly assist.</p>
      <h5 class="h5-responsive mt-3">
        <i class="fa fa-envelope green-text" aria-hidden="true"></i>
        <a [href]='mailLink'>{{supportEmail}}</a>
      </h5>
      <h5 class="h5-responsive mt-3">
        <i class="fa fa-phone blue-text" aria-hidden="true"></i>
        <a [href]='phoneLink'>{{supportPhone}}</a> Available M-F 8-5PM MST except on holidays
      </h5>
      <h2 class="h2-responsive pt-5">Training and Support Resources</h2>
      <p>Having login problems, account questions, or need training support? We've created our <b>Knowledge Base</b> of
        support articles to assist you.
        Before contacting us please check out knowledge base for answers to any questions you may have.
      </p>
      <div class="col text-center">
        <a target="_blank" href="https://discoverandchange.zendesk.com/hc/" class="btn btn-secondary waves-light"
          mdbRippleRadius>Go to Knowledge Base</a>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/help/help.component.html